import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.PostJob = {
  displayName: 'PostJob',

  component: React.createClass({
    getInitialState: function() {
      return {
        loading: true
      }
    },

    componentDidMount: function() {
      let job = Job.Data;
      const $modalFooter = $('#job-modal').find('.modal-footer')

      $modalFooter.hide()

      var subcats = []
      for (var j = 0; j < job.categories.length; j++) {
        subcats[j] = { type: 'subcategories',
                       id: job.categories[j].id }
      }

      var jobCreateData = {
        data: {
          type: 'jobs',
          attributes: {
            description: job.description,
            starting:    job.schedule === '' ? 'flexible' : job.schedule.replace(/_/g, ' '),
            budget:      job.minBudget,
            min_budget:  job.minBudget,
            max_budget:  job.maxBudget,
            can_call:    job.canCall,
            schedule:    job.schedule === '' ? 'flexible' : job.schedule,
            preferred_outcome: job.preferredOutcome,
            interested_in_best_pro: job.interestedInBestPro,
            contact_preference: job.contactPreference,
            disable_processing: true
          },
          relationships: {
            suburb: {
              data: {
                type: 'suburbs',
                id: job.suburb_id
              }
            },
            'job-subcategories': {
              data: subcats
            },
            'exclusive-to-business': {
              data: {
                type: 'businesses',
                id: Job.Data.exclusiveFor
              }
            }
          }
        },
        'included': [
          {
            'type': 'alliance-partners',
            'attributes': { 'name': job.originName }
          },
          {
            'type': 'job-referrers',
            'attributes': Job.Data.referrer
          },
          {
            'type': 'tracking-data',
            'attributes': {
              'creative':     decodeURI(Cookies.get('creative')),
              'keyword':      decodeURI(Cookies.get('keyword')),
              'matchtype':    decodeURI(Cookies.get('matchtype')),
              'adposition':   decodeURI(Cookies.get('adposition')),
              'campaignid':   decodeURI(Cookies.get('campaignid')),
              'adgroupid':    decodeURI(Cookies.get('adgroupid')),
              'geo':          decodeURI(Cookies.get('geo')),
              'utm_campaign': decodeURI(Cookies.get('utm_campaign')),
              'utm_source':   decodeURI(Cookies.get('utm_source')),
              'utm_medium':   decodeURI(Cookies.get('utm_medium')),
              'utm_content':  decodeURI(Cookies.get('utm_content')),
              'gclid':        decodeURI(Cookies.get('gclid'))
            }
          }
        ]
      }

      $.ajax(SS.API.V3.jobCreate(jobCreateData))
        .done(function(createdJson) {
          Job.PostingProgressActions.updateTracking({ jobId: createdJson.data.id })
          Job.Data.id = createdJson.data.id
          let creditCard = createdJson.data.attributes.creditCard
          if (creditCard) {
            Job.Data.with_cc   = true
            Job.Data.cc_number = creditCard.number
          }
          SS.appFn.appMsg({ id: createdJson.data.id }) // used by mobile app for controlling the flow

          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ event: 'custom.event.submitJob' });

          if(job.attachments.length) {
            uploadFilesToJob(createdJson.data.id)
          } else {
            redirectToJobPage()
          }
        })
        .fail(function() {
          document.location.href = '/500'
        });

      function uploadFilesToJob(jobId) {
        let files = job.attachments
        let requests = []

        var fl = files.length;

        for (var i = 0; i < fl; i++) {
          buildRequests(i)
        }

        function buildRequests(i) {
          let formData = new FormData()
          let apiData = JSON.stringify(SS.API.V3.build.attachment({jobId: jobId}))

          formData.append('attachment', apiData)
          formData.delete && formData.delete('file') // doesn't exist on safari mobile
          formData.append('file', files[i])

          let request = SS.API.V3.attachment({data: formData})
          request.beforeSend = () => {
            $('.status-message').text(`Uploading ${files[i].name}...`)
          }
          requests.push(request)
        }

        function processUploads(index) {
          if (index < requests.length) {
            $.ajax(requests[index])
            .always(() => {
              processUploads(index + 1)
            })
            .fail(() => {
              setAttachmentError()
            })
          } else {
            $('.status-message').text("All Done!")
            redirectToJobPage()
          }
        }

        processUploads(0)
      }

      function setAttachmentError(){
        Cookies.set('job-attachment-error', Job.Data.id)
      }

      function redirectToJobPage(){
        document.location.href = redirectUrl()

        function redirectUrl() {
          let jobID = Job.Data.id

          switch (Job.Data.referrer.cta) {
            case 'profile': {
              return `/jobs/${jobID}/profilejob?pending_job=true`
            }
            case 'business_directory_card': {
              return `/jobs/${jobID}/bcardjob?pending_job=true`
            }
            default: {
              return `/jobs/${jobID}/posted?pending_job=true`
            }
          }
        }
      }
    },

    render: function() {
      return (
        <div className="modal-body job-form-body radius-16-bottom">
          <h3>Saving your job details...
            <div className="spinner-icon text-center" style={{marginLeft: '15px'}}/>
          </h3>
          <p>
            <i className="status-message"></i>
            <div className="spinner-icon text-center" style={{marginLeft: '15px'}}/>
          </p>
        </div>
      )
    }
  })
}
